export enum Role {
    ThirdParty = 'third-party',
    Customer = 'customer',
}
